import { render, staticRenderFns } from "./GImport.vue?vue&type=template&id=191b6e4d&scoped=true"
import script from "./GImport.vue?vue&type=script&lang=js"
export * from "./GImport.vue?vue&type=script&lang=js"
import style0 from "./GImport.vue?vue&type=style&index=0&id=191b6e4d&prod&lang=css"
import style1 from "./GImport.vue?vue&type=style&index=1&id=191b6e4d&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "191b6e4d",
  null
  
)

export default component.exports